import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BehaviorSubject } from "rxjs";
import { ACCOUNTTYPES } from "../model/types/Types";
import { AnimationPlayer } from "@angular/animations";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  serverUrl: String = environment.serverUrl;
  constructor(private httpClient: HttpClient) {}

  //call to open menu when user have token if not then it returns
  public get loggedIn(): boolean {
    return localStorage.getItem("token") !== null;
  }
  login(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/login",
      model,
      httpOptions
    );
  }

  check_userpreference(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/userpreference",
      model,
      httpOptions
    );
  }
  getPermissionsByAppId(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/permissions-byappid",
      model,
      httpOptions
    );
  }
  SaveBrowserState(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/save-browser-state",
      model,
      httpOptions
    );
  }

  getLoginStatebyId(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.get(this.serverUrl + "auth/loginstate-byid/" + id);
  }
  updateLoginState(savemodel: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/update-loginstate/" + savemodel._id,
      savemodel,
      httpOptions
    );
  }
  SaveUser(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/saveuser",
      model,
      httpOptions
    );
  }

  register(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.httpClient.post(
      this.serverUrl + "auth/register",
      model,
      httpOptions
    );
  }
  addUser(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    model.create_mode = 3;
    return this.httpClient.post(
      this.serverUrl + "auth/adduser-gsf",
      model,
      httpOptions
    );
  }
  importUserToClient(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/add-client-user",
      model,
      httpOptions
    );
  }
  getuser_permissions(model) {
    return this.httpClient.post(this.serverUrl + "auth/getpermission", model);
  }

  listallUsers() {
    return this.httpClient.get(this.serverUrl + "auth/listallusers");
  }
  listallDeletedUsers_within_App(
    id: any,
    pageNumber: number = 1,
    pageSize: number = 0,
    sortField = null,
    sortType = null,
    searchText = null,
    searchField = null,
    startDate = null,
    endDate = null
  ) {
    if (!searchText) searchText = "";
    return this.httpClient.get(
      this.serverUrl + "auth/listdeletedusers-within-org/" + id,
      {
        params: new HttpParams()
          .set("pageNumber", pageNumber.toString())
          .set("pageSize", pageSize.toString())
          .set("sortField", sortField)
          .set("sortType", sortType)
          .set("searchText", searchText)
          .set("searchField", searchField)
          .set("startDate", startDate)
          .set("endDate", endDate)
      }
    );
  }
  listallUsersWithinOrg(
    id: any,
    pageNumber: number = 1,
    pageSize: number = 0,
    sortField = null,
    sortType = null,
    username = null,
    status = null
  ) {
    if (!username ) username = "";
    if (!status ) status = "";
    return this.httpClient.get(
      this.serverUrl + "auth/listallusers-within-org/" + id,
      {
        params: new HttpParams()
          .set("pageNumber", pageNumber.toString())
          .set("pageSize", pageSize.toString())
          .set("sortField", sortField)
          .set("sortType", sortType)
          .set(`username`, username)
          .set(`status`, status),
      }
    );
  }
  listallUsers_pagination(pageNumber: any) {
    return this.httpClient.get(
      this.serverUrl + "auth/listallusers-across-portal/" + pageNumber
    );
  }
  listallUsers_within_App(id: any) {
    return this.httpClient.get(
      this.serverUrl + "auth/listallusers-within-app/" + id
    );
  }

  deleteUser(id: any, clientId: any, model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.delete(
      this.serverUrl +
        `auth/deleteuser/${id}/${clientId}/${model.orginalClient}`
    );
  }
  updateUser(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/updateuser/" + model._id,
      model,
      httpOptions
    );
  }

  changePassword(id: any, model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/change-organizationUser-password/" + id,
      model,
      httpOptions
    );
  }
  resetPassword(id: any, model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/reset/password/" + id,
      model,
      httpOptions
    );
  }
  changePasswordGSF(id: any, model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/change-app-password/" + id,
      model,
      httpOptions
    );
  }

  getuserbyId(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.get(
      this.serverUrl + "auth/userbyid/" + id,
      httpOptions
    );
  }

  listallRoles() {
    return this.httpClient.get(this.serverUrl + "auth/listallroles");
  }
  listallRoles_withinApp(id: any) {
    return this.httpClient.get(
      this.serverUrl + "auth/listallroles-within-app/" + id
    );
  }
  getRolesForApplications(applicationsId: Array<any>) {
    return this.httpClient.post(
      this.serverUrl + "auth/listallrole-forMultiple-apps",
      { applicationsId }
    );
  }
  getrolebyId_users(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.get(
      this.serverUrl + "auth/rolebyid-users/" + id,
      httpOptions
    );
  }

  AddRole(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/addrole",
      model,
      httpOptions
    );
  }

  getrolebyId(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.get(
      this.serverUrl + "auth/rolebyid/" + id,
      httpOptions
    );
  }

  updateRole(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/updaterole/" + model._id,
      model,
      httpOptions
    );
  }
  deleteRole(id: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.delete(
      this.serverUrl + "auth/deleterole/" + id,
      httpOptions
    );
  }
  getPermissionbyId(id: any, appId: any, clientId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.get(
      this.serverUrl +
        "auth/permissionbyid/" +
        id +
        "/" +
        appId +
        "/" +
        clientId,
      httpOptions
    );
  }
  updatePermisions(model: any, id: any, clientId: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.post(
      this.serverUrl + "auth/updatepermission/" + id + "/" + clientId,
      model,
      httpOptions
    );
  }
  updateUserbyusernameAppid(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/updateuser-byusername-appid",
      model,
      httpOptions
    );
  }
  deleteUserbyusernameAppid(model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      this.serverUrl + "auth/deleteuser-byusername-appid",
      model,
      httpOptions
    );
  }
  updateuserStatus(model: any) {
    debugger;
    var fd = new FormData();
    Object.entries(model).forEach(([key, value]) => {
      fd.append(key, <any>value);
    });
    fd.append("updatedBy", localStorage.getItem("user_id"));
    return this.httpClient.post(this.serverUrl + "auth/updateuser-status/", fd);
  }
  getTokenDetails(tokenData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };

    return this.httpClient.post(
      this.serverUrl + "auth/decryptToken",
      { token: tokenData },
      httpOptions
    );
  }

  getSupportingdoc(fileId: string, userId: string) {
    return this.httpClient.get<Blob>(
      this.serverUrl + "auth/user-supporting-document/" + userId + "/" + fileId,
      { responseType: "blob" as "json" }
    );
  }
  forgotPassword(data: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      }),
    };
    data.returnUrl = environment.forgetPasswordReturnUrl;
    return this.httpClient.post(
      this.serverUrl + "auth/forgot-password-org",
      data,
      httpOptions
    );
  }
  getOrganizationUserDetails(id) {
    return this.httpClient.get(
      this.serverUrl + "auth/organization-user-details/" + id
    );
  }
  updateOrganizationUserDetails(id, userDetails) {
    return this.httpClient.post(
      this.serverUrl + "auth/update-organization-user-details/" + id,
      userDetails
    );
  }
  getUserAccountHistory(id: any) {
    return this.httpClient.get(
      this.serverUrl + "auth/user-account-history/" + id
    );
  }
  listRolesOfClientForApplication(applicationid: any, clientId: any) {
    return this.httpClient.get(
      this.serverUrl + "auth/client-app-roles/" + clientId + "/" + applicationid
    );
  }
  createClientClone(model: {
    reference_client: string;
    selectedApps: [];
    options: { roles: boolean; permissions: boolean };
    name: string;
    tenant: string;
    username: string;
    password: string;
    accountType: ACCOUNTTYPES;
    existingUsername: string;
  }) {
    return this.httpClient.post(this.serverUrl + "auth/client/clone", model);
  }
  checkPasswordResetLinkValidity(data) {
    return this.httpClient.post(
      this.serverUrl + "auth/check-reset-password-link",
      data
    );
  }
  resetOrgPassword(data) {
    return this.httpClient.post(
      this.serverUrl + "auth/change-org-user-password",
      data
    );
  }
  ResetPassword(id: any,org_id:string, model: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + localStorage.getItem("token")
      }),
    };
    return this.httpClient.put(
      `${this.serverUrl}auth/change-password/${org_id}/${id}`,
      model,
      httpOptions
    );
  }
  getOrgUsersStats(orgId) {
    return this.httpClient.get(
      this.serverUrl + "auth/org-users-stats/" + orgId
    );
  }
  getUsersImportTemplate(clientId, appId) {
    return this.httpClient.get(
      this.serverUrl + "auth/user-import-template/" + clientId + "/" + appId,
      { responseType: "blob" }
    );
  }
  uploadTemplate(file: File, clientId, appId) {
    const formData: FormData = new FormData();
    formData.append("bulkUserTemplate", file, file.name);
    return this.httpClient.post(
      this.serverUrl + "auth/bulk-user-import/" + clientId + "/" + appId,
      formData
    );
  }
  /**
   *
   * @param {string} clientId client id
   * @returns {Array} List of batch jobs
   */
  getBatchJobs(clientId) {
    return this.httpClient.get(this.serverUrl + "auth/batch-jobs/" + clientId);
  }

  logout() {
    const httpOptions = {
      headers: new HttpHeaders({
        // 'Cache-Control': 'no-cache',
        // 'Pragma': 'no-cache',
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      }),
    };
    return this.httpClient.get(
      this.serverUrl + "exgsfsso/gsf/logout",
      httpOptions
    );
  }
}
